// GENERATED by npm run generate-graphql-operations
const RemoveFromLibrary = 'mutation RemoveFromLibraryWeb($pandoraId: String!) {   removeFromLibrary(id: $pandoraId) {     status   } } ';
export default RemoveFromLibrary;
